module.exports = __webpack_public_path__ + "static/fonts/Roboto-Medium.7b225d4.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/concierge/font/roboto/Roboto-Medium.woff
// module id = z/40
// module chunks = 0